<template>
  <container>
    <checkout-progress />
    <type-switcher />
    <c-gift-cards-body />

    <transition name="transition-fade">
      <payment-methods v-if="!IS_IE && !$store.state.showTicketSelection">
        <span>{{ $t('availablePaymentOptions') }}</span>
      </payment-methods>
    </transition>
  </container>
</template>

<script>
import CGiftCardsBody from '../components/CGiftCardsBody.vue'
import checkoutProgress from '../components/checkoutProgress.vue'
import container from '../components/container.vue'
import paymentMethods from '../components/paymentMethods.vue'
import typeSwitcher from '../components/typeSwitcher.vue'

import { IS_IE, GAP_GIFT_CARD } from '../settings.js'

export default {
  name: 'VGiftCardsIndex',

  components: {
    CGiftCardsBody,
    checkoutProgress,
    container,
    paymentMethods,
    typeSwitcher
  },

  computed: {
    IS_IE: () => IS_IE
  },

  created () {
    this.$store.state.isReservation = false
    this.$store.state.isGiftcardOrder = true
    if (
      (this.$store.state.cart.tickets && this.$store.state.cart.tickets.gap === GAP_GIFT_CARD) ||
      (this.$store.state.cart.events && this.$store.state.cart.events.gap === GAP_GIFT_CARD)
    ) {
      this.$store.dispatch('clearCart', { dontResetSelection: true })
    }
  }
}
</script>

<i18n locale="en">
{
  "availablePaymentOptions": "Available payment options:"
}
</i18n>

<i18n locale="de">
{
  "availablePaymentOptions": "Verfügbare Zahlungsarten:"
}
</i18n>
